module.exports = __webpack_public_path__ + "static/media/reasons-members.1a97c932.png";